import React from 'react';
import _ from 'lodash';
import { FormattedMessage as RiFormattedMessage } from 'react-intl';

import textUtils from '../util/text';

class FormattedMessage extends React.Component {
  static defaultProps = {
    mode: '',
  };

  render() {
    const { mode, prefix, plural, determiner } = this.props;

    if (mode === 'capitalize') {
      return (
        <RiFormattedMessage {...this.props}>
          {(text) => <span>{_.upperFirst(textUtils.format(text, prefix, plural, determiner))}</span>}
        </RiFormattedMessage>
      );
    } else {
      return (
        <RiFormattedMessage {...this.props}>
          {(text) => <span>{textUtils.format(text, prefix, plural, determiner)}</span>}
        </RiFormattedMessage>
      );
    }
  }
}

export default FormattedMessage;
